<template>
<comp-feature v-if="!expanded" theme="light">
    <sec v-if="submitted">
        <message :message="submittedMessage" type="success" />
        <footer>
            <a role="button" @click="expanded = true">Enter a New Request</a>
        </footer>
    </sec>
    <sec v-else heading="Don’t know your part number? Try our exclusive Caterpillar® Parts Lookup tool." level="0">
        <footer>
            <a role="button" @click="expanded = true">Part Concierge</a>
        </footer>
    </sec>
</comp-feature>
<article v-else>
    <sec heading="Part Concierge - Our Exclusive Online Caterpillar® Parts Locator">
        <sec heading="Machine *" :level="subLevel" :error="error('Machine')">
            <input v-model="fields.Machine" type="text" placeholder="Machine Make">
        </sec>
        <sec heading="Model *" :level="subLevel" :error="error('Model')">
            <input v-model="fields.Model" type="text" placeholder="Model">
        </sec>
        <sec heading="Serial Number" :level="subLevel">
            <input v-model="fields.Serial" type="text" placeholder="Serial Number">
        </sec>
        <sec heading="Arrangement" :level="subLevel">
            <input v-model="fields.Arrangement" type="text" placeholder="Arrangement Number">
        </sec>
        <sec heading="Description *" :level="subLevel" :error="error('Description')">
            <textarea v-model="fields.Description" placeholder="Description of Part"></textarea>
        </sec>
        <sec heading="Contact Name *" :level="subLevel" :error="error('Name')">
            <input v-model="fields.Name" type="text" placeholder="Contact Name">
        </sec>
        <sec heading="Email *" :level="subLevel" :error="error('Email')">
            <input v-model="fields.Email" type="text" placeholder="Email Address">
        </sec>
        <sec heading="Phone *" :level="subLevel" :error="error('Phone')">
            <input v-model="fields.Phone" type="tel" placeholder="(___) ___-____" v-mask="'(###) ###-####'" >
        </sec>
        <template slot="footer">
            <button @click="submit">Send Request</button>
            <button @click="close(); reset()" class="delete">Cancel</button>
        </template>
    </sec>
</article>
</template>

<script>
const   backfills = ['createConcierge'];

    import { backfill, backfillData, modalErrors, toast, formValidator } from '../../components/utils/globals';
    import { emailRegEx } from '../api/constants';

export default {
    computed: {
        
    },
    data: backfillData({
        loading: false,
        expanded: false,
        fields: {
            Machine: '',
            Model: '',
            Serial: '',
            Arrangement: '',
            Description: '',
            Name: '',
            Email: '',
            Phone: ''
        },
        errors: {},
        subLevel: 3,
        validate: formValidator({
            Machine: {message:'Machine Required'},
            Model: {message:'Model Required'},
            Description: {message:'Description Required'},
            Name: {message:'Contact Name Required'},
            Email: {message:'Valid Email Required',validator(email){ return !emailRegEx.test(email); }},
            Phone: {message:'Valid Phone Number Required',validator(phone){ return phone.length !== 14; }},
        }),
        submitted: false,
        submittedMessage: 'Thank you for your inquiry. The information has been sent to an Off Road sales team specialist. You will be contacted with price and availability during normal business hours: <br> (Monday through Friday 8 AM to 5 PM EST).',
    },backfills),
    components: {
        Loading: () => import('./items/loading.vue'),
        Sec: () => import('./containers/section.vue'),
        Message: () => import('./items/message.vue'),
    },
    methods: {
        error(key){
            return this.errors[key];
        },
        formCheck(){
            let valid = this.validate(this.fields);
            this.errors = valid.errors;
            return valid.passed;
        },
        reset(){
            this.submitted = false;
            Object.keys(this.fields).forEach( key => this.fields[key] = '');
        },
        close(){
            this.expanded = false;
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        },
        submit(){
            if(this.formCheck()){
                this.createConcierge(this.fields)
                .then( () => {
                    this.close();
                    this.reset();
                    this.submitted = true;
                    toast({message:'Part Concierge Request Sent',theme:'success'});
                }).catch( e => toast({message:'Error Sending Request',theme:'error'}) );  
            }
            else { modalErrors(this) }
        }
    },
    created() {
        backfill(this,import('../api/parts'),backfills);
    },
    watch: {
		fields: {
			handler() {
				if(Object.keys(this.errors).length > 0){
                    this.formCheck();
                }
			},
			deep: true
        },
	}
};
</script>